import axios from '@/http'

//登录
export function loginApi(data) {
    return axios({
        url: '/api/user/login',
        method: 'POST',
        data
    })
}

//检测是否有登录状态
export function getLoginStatusApi(data) {
    return axios({
        url: '/api/site/get-login-status',
        method: 'GET',
        params: data
    })
}

//检测是否显示验证码
export function getCaptchaStatusApi(data) {
    return axios({
        url: '/api/user/is-show-verify-code',
        method: 'GET',
        params: data
    })
}

//获取验证码
export function getCaptchaApi(data) {
    return axios({
        url: '/api/site/get-captcha',
        method: 'GET',
        params: data
    })
}

//获取微信扫码登录的二维码
export function wechatConnectUrl(data) {
    return axios({
        url: '/api/wechat-login/qr-connect',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-检测是否已绑定爱米用户
export function wechatCheckBind(data) {
    return axios({
        url: '/api/wechat-login/check-bind',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-登录接口
export function wechatLogin(data) {
    return axios({
        url: '/api/wechat-login/login',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-绑定爱米用户
// export function wechatBind(data){
//     return axios({
//         url: '/api/wechat-login/bind',
//         method: 'GET',
//         params: data
//     })
// }
export function wechatBind(data) {
    return axios({
        url: '/api/wechat-login/bind',
        method: 'POST',
        data
    })
}
export function getChannelPackApi(data) {
    return axios({
        url: '/api/teacher-applet/get-channel-pack',
        method: 'POST',
        data
    })
}
export function getStuQr() {
    return axios({
        url: '/api/site/custom-service',
        method: 'GET',
    })
}
